const reducer = (key, value) => {
    switch (key) {
        case 'date_end':
            if (value && typeof value !== 'number') return `${key} must be a number`
            break
        case 'date_start':
            if (value && typeof value !== 'number') return `${key} must be a number`
            break
        case 'name':
            if (typeof value !== 'string') return `${key} must be a string`
            if (value.length < 3) return `At least three characters`
            break
        case 'slug':
            if (value && typeof value !== 'string') return `${key} must be a string or undefined`
            if (typeof value !== 'string' && value.length < 3) return `At least three characters`
            break
        default:
            return null
    }
}

const compareValues = (values) => {
    const out = {}
    const { date_end, date_start } = values

    if (date_end && date_start && date_end <= date_start) {
        out.date_end = 'Must be later than Start Date'
    }

    return out
}

const validate = (values) => ({
    ...compareValues(values),
    ...Object.keys(values).reduce((obj, k) => {
        const out = obj
        const error = reducer(k, values[k])
        if (error) out[k] = error
        return obj
    }, {}),
})

export default validate
